import React, { useContext } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { CityLaunchContext } from "../../context/CityLaunchContext";
import { PRESS_HOVER, PRESS_TAP, PRESS_TRANSITION } from "../../utils/motionInteractions";

export default function CityLaunchBanner() {
  const { t } = useTranslation("events");
  const { city, eligible, applied, openLaunch } = useContext(CityLaunchContext);
  if (!eligible) return null;
  return (
    <motion.button
      type="button"
      onClick={openLaunch}
      whileHover={PRESS_HOVER}
      whileTap={PRESS_TAP}
      transition={PRESS_TRANSITION}
      className="relative mb-3 flex min-h-[60px] w-full items-center overflow-hidden rounded-2xl border border-orange-200/75 bg-gradient-to-r from-orange-600 via-orange-500 to-amber-500 px-4 py-2 text-left text-white shadow-[0_10px_24px_rgba(194,83,13,0.22),inset_0_1px_0_rgba(255,255,255,0.28)]"
    >
      <span className="min-w-0 flex-1 pr-8">
        <span className="block text-lg font-semibold leading-tight">{t("city_launch.banner_title", { city })}</span>
        <span className="block text-sm font-medium leading-5">{t(applied ? "city_launch.banner_applied" : "city_launch.apply")}</span>
      </span>
      <img src="/assets/events/right_arrow.svg" alt="" className="h-5 w-7 shrink-0" />
    </motion.button>
  );
}
